import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Copy, Check } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export function driverDetailRows(d, me) {
  return [
    ["Driver Name", d.name], ["Driver Cell", d.phone], ["Truck#", d.truck], ["Trailer#", d.trailer], ["VIN", d.vin],
    ["CDL No.", d.cdl_number], ["CDL State", d.cdl_state], ["Tracking Option Available", (d.tracking_options || []).join(", ")],
    ["Dispatcher Name", me?.name], ["Dispatcher #", me?.direct_line || me?.phone],
  ];
}

export function DriverCopyBox({ driver, onClose }) {
  const { user } = useAuth();
  const [copied, setCopied] = useState(false);
  if (!driver) return null;
  const rows = driverDetailRows(driver, user);
  const text = rows.map(([k, v]) => `${k}: ${v || "—"}`).join("\n");

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (e) {
      const ta = document.createElement("textarea");
      ta.value = text; document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
    }
    setCopied(true); toast.success("Driver details copied");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Dialog open={!!driver} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white border-slate-200 max-w-lg" data-testid="driver-copy-dialog">
        <DialogHeader><DialogTitle className="font-heading">{driver.name}</DialogTitle><DialogDescription className="text-slate-500">Driver details with your dispatcher contact. Copy them with one click.</DialogDescription></DialogHeader>
        <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 font-mono text-[13px] leading-relaxed" data-testid="driver-copy-box">
          {rows.map(([k, v]) => (
            <div key={k} className="grid grid-cols-[190px_1fr] gap-2">
              <span className="text-slate-500">{k}:</span><span className="text-slate-900 break-words select-all">{v || "—"}</span>
            </div>
          ))}
        </div>
        {!(user?.direct_line || user?.phone) && <p className="text-xs text-amber-700" data-testid="driver-copy-no-phone">Add your phone number in your profile so it shows as Dispatcher #.</p>}
        <Button onClick={copy} className="w-full bg-blue-600 text-white hover:bg-blue-700 font-semibold" data-testid="driver-copy-all-btn">
          {copied ? <Check size={16} weight="bold" className="mr-1.5" /> : <Copy size={16} weight="bold" className="mr-1.5" />}{copied ? "Copied" : "Copy All"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
